<div class="c-form__item u-layout-auto tooltip" [ngClass]="checkBlock.width">
  <div
    class="c-block"
    [ngClass]="{ 'c-block--selected': checkBlock.checked }"
    (click)="toggle()"
  >
    <i class="fa fa-check" aria-hidden="true"></i>
  </div>
  <div class="tooltip__content tooltip--top tooltip-dark">
    {{ checkBlock.tooltip }}
  </div>
</div>
